import * as React from 'react';
import { Persona } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * temp for demo
 */
export const StaticProfile = _ref => {
  let {
    user
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("div", {
      style: {
        width: '200px'
      },
      children: /*#__PURE__*/_jsx(Persona, {
        coinSize: 30,
        hidePersonaDetails: false,
        text: user.name
      })
    })
  });
};